import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "../../styles/fonts.css";
import def from "../../img/prof default.png";
import moment from "moment";
const CollectionLec = ({ prof }) => {
  return (
    <div className=' col-xl-3 col-lg-4 m-2 col-md-4 col-12 rounded-lg'>
      <div className='card'>
        <Link to={`/acad/lec/${prof.id}`} className='text-dark m-0 p-0'>
          <img src={def} className='card-img' alt='...' />
          <div className='card-body'>
            <h4 className='card-title fontcool text-center'>
              {prof.subject}:{prof.id.split("2020")[1]} {prof.name}
            </h4>
            <p>
              <span className='blue-grey-text text-lighten-2'>
                {moment(prof.date.toDate()).format("MMMM Do YYYY, HH:MM")}{" "}
              </span>
            </p>
            <p className='card-text simplefont text-center'>
              {prof.description}
            </p>
            <p className='card-text text-right slantfont'>{prof.prof}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CollectionLec;
